import { Store } from "../../../Application/Store/Store";
import { ADD_DENIED_SERVICE, USER_DISCONNECTED } from 'Application/Store/Actions/UserTypes';
import { SET_MANDI_ADJUST } from 'Application/Store/Actions/ViewportTypes';

const BYPASS_ACCESS = false;

export const dispatchMandiAdjustment = (extraData) => {
    if (!extraData) return;

    const adjustment = {
        x: extraData.biteJump?.x || 0,
        y: -(extraData.biteJump?.y || 0),
        z: extraData.biteJump?.z || 0,
    };

    Store.dispatch({ type: SET_MANDI_ADJUST, payload: adjustment });
    return adjustment;
};

export const dispatchPlayerIncrementation = (extraData) => {
    if (!extraData) return;

    const playerData = extraData.playerData;
    if (!playerData) return;

    const increment = playerData.increment;
    if (increment) {
        Store.dispatch({ type: 'SET_INCREMENT', payload: increment });
    }

    const nbMaxi = playerData.nbMaxi;
    if (nbMaxi) {
        Store.dispatch({ type: 'SET_NBMAXI', payload: nbMaxi });
    }

    const nbMandi = playerData.nbMandi;
    if (nbMandi) {
        Store.dispatch({ type: 'SET_NBMANDI', payload: nbMandi });
    }

    return increment;
};

export const dispatchDeniedServices = (extraData) => {
    if (!extraData) return;

    const caseData = extraData.caseData;
    if (!caseData) return;

    const servicesAuthorized = caseData.servicesAuthorized;
    if (!servicesAuthorized) return;

    if (BYPASS_ACCESS) {
        return servicesAuthorized;
    }

    Object.entries(servicesAuthorized).forEach(([key, value]) => {
        if (!value) {
            Store.dispatch({ type: ADD_DENIED_SERVICE, payload: key });
        }
    });

    if (Store.getState().UserReducer.connected && Store.getState().UserReducer.deniedServices.includes('connection')) {
        Store.dispatch({ type: USER_DISCONNECTED, payload: false });
    }

    return servicesAuthorized;
};
